import { useForm } from "react-hook-form";
import dayjs from "dayjs";

const useFilters = ({ onFilterChange }) => {
  const form = useForm();

  const onSubmit = (formData) => {
    const queryParams = Object.entries(formData).reduce((acc, [key, value]) => { 
      if (value) {
        if (Array.isArray(value) && value.length > 0 && key !== "trip_created_date" && key !== "traveller_date"  ) {
          value.forEach((val) => {
            acc.push(`${key}=${encodeURIComponent(val)}`);
            if (key === "purchase_method" && val === "BULK") {
              acc.push(`purchase_method=${encodeURIComponent("SINGLE")}`);
            }
          });
        } else if (key === "ordering") {
          acc.push(`ordering=${encodeURIComponent(value)}`);
        } else if (
          Array.isArray(value) &&
          value.length > 0 &&
           (key === "trip_created_date"  ||   key === "traveller_date" )
        ) {
          
          const [start_date, end_date] = value;
          const formatStartDate = start_date
            ? dayjs(start_date).format("YYYY-MM-DD")
            : null;

          const formatEndDate = end_date
            ? dayjs(end_date).format("YYYY-MM-DD")
            : null;

          if (formatStartDate) {
            let gen  = key === 'trip_created_date' ? "start_date":'trip_state_date'
            acc.push(`${gen}=${encodeURIComponent(formatStartDate)}`);
          }

          if (formatEndDate) {
            let gen  = key === 'trip_created_date' ? "end_date":'trip_end_date'
            acc.push(`${gen}=${encodeURIComponent(formatEndDate)}`);
          }

        }
      
        
        else if (typeof value === "boolean") {
          acc.push(`${key}=${encodeURIComponent(value ? "True" : "False")}`);
        } else {
          acc.push(`${key}=${encodeURIComponent(value)}`);
        }
      }
      return acc;
    }, []);

    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    onFilterChange(queryString);
  };

  return {
    form,
    onSubmit,
  };
};

export default useFilters;
